import React from 'react';
import { ArrowPathIcon, DocumentDuplicateIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';

const PLACEHOLDER = '{TRANSCRIPT}';

export const NewTemplateButton = ({ onClick }) => (
  <button type="button" className="pt-btn pt-btn-primary" onClick={onClick}>
    <PlusIcon /> New template
  </button>
);

const NoTemplateOpen = ({ onNew }) => (
  <div className="pt-editor pt-blank">
    <strong>No template open</strong>
    <span>Pick a template on the left, or create a new one.</span>
    <NewTemplateButton onClick={onNew} />
  </div>
);

/** Right pane: name and prompt of the open template, with Duplicate / Delete / Save. */
export default function TemplateEditor({ library }) {
  const {
    selectedId, isDraft, name, setName, prompt, setPrompt, nameRef, dirty, saving, error,
    startNew, duplicate, save, remove,
  } = library;

  if (!selectedId) return <NoTemplateOpen onNew={startNew} />;

  return (
    <form className="pt-editor" onSubmit={save}>
      <label className="pt-field" htmlFor="pt-name">
        <span>Name</span>
        <input
          id="pt-name"
          ref={nameRef}
          type="text"
          className="pt-control"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Djibouti briefing"
        />
      </label>

      <label className="pt-field" htmlFor="pt-prompt">
        <span>Prompt</span>
        <textarea
          id="pt-prompt"
          className="pt-control pt-prompt"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          rows={20}
          placeholder={`Paste the full prompt. Put ${PLACEHOLDER} where the transcript should go, or leave it out and it is added at the end.`}
        />
      </label>

      <p className="pt-note">
        <code>{PLACEHOLDER}</code> is optional — it only decides where the transcript
        lands. Leave it out and the transcript is appended after your prompt.
      </p>

      {error && <div className="pt-error">{error}</div>}

      <div className="pt-actions">
        {!isDraft && (
          <>
            <button type="button" className="pt-btn" onClick={duplicate}>
              <DocumentDuplicateIcon /> Duplicate
            </button>
            <button type="button" className="pt-btn pt-btn-danger" onClick={remove}>
              <TrashIcon /> Delete
            </button>
          </>
        )}
        <button type="submit" className="pt-btn pt-btn-primary" disabled={saving || !dirty}>
          {saving ? <><ArrowPathIcon className="pt-spin" /> Saving...</> : 'Save'}
        </button>
      </div>
    </form>
  );
}
